import React from 'react';
import { Link } from 'react-router';
import Menu from '../menu/Menu';
import './Nav.css';

export default function Nav() {
  return (
    <>
      <nav>
        <h1>
          <Link
            to='/'
            class='title-link'
          >
            H.N. Fisher
          </Link>
        </h1>
        <Link
          to='/'
          class='link'
        >
          Home
        </Link>

        {/* <Link
          to='/books'
          class='link'
        >
          Books
        </Link> */}

        <Link
          to='/about'
          class='link'
        >
          About
        </Link>

        <Link
          to='/contact'
          class='link'
        >
          Contact
        </Link>
        <span>
          <Menu />
        </span>
      </nav>
    </>
  )
}
